/**
 * Logic for table view / layout state (height modes, maximize, split screen).
 */

export function computeIsMaximizedOrSplitScreen(
  isMaximized: boolean,
  isSplitScreen: boolean,
  isFocused: boolean
): boolean {
  return ((isMaximized || isSplitScreen) && !isFocused) ?? false;
}

export function computeIsFixedHeight(
  isMaximizedOrSplitScreen: boolean,
  hasMaximumHeight: boolean,
  enableTableFixedHeightAsDefault: boolean
): boolean {
  return !isMaximizedOrSplitScreen && (hasMaximumHeight || enableTableFixedHeightAsDefault);
}

export function computeIsFullHeight(isFixedHeight: boolean, isMaximizedOrSplitScreen: boolean): boolean {
  return !isFixedHeight && !isMaximizedOrSplitScreen;
}

export function computeCanMaximize(
  disableMaximizedTables: boolean,
  tableProvenanceUuid: string | null
): boolean {
  return !disableMaximizedTables && tableProvenanceUuid != null;
}

export function computeCanSplitScreen(
  setSplitScreenTable: ((uuid: string) => void) | undefined,
  isSetSplitScreenTableNoop: boolean,
  tableProvenanceUuid: string | null
): boolean {
  return Boolean(setSplitScreenTable) && !isSetSplitScreenTableNoop && tableProvenanceUuid != null;
}
